import {
    CheckboxPickerV2,
    InputV2,
    SelectV2,
    SwitchV2,
} from '@elements'

export const TableFilter = ({ column }) => {
    const columnFilterValue = column.getFilterValue()
    const { filterVariant, options, placeholder } = column.columnDef.meta ?? {}

    const multiSelectValue = () => {
        if (!options || !Array.isArray(options)) {
            return []
        }

        const arrayColumnFilterValue = String(columnFilterValue).split(',')

        return options
            .map(option => {
                if (typeof option === 'string') {
                    return { value: option, label: option }
                }
                return option
            })
            .filter(option => arrayColumnFilterValue.includes(String(option.value)))
    }

    return filterVariant === 'select' ? (
        <SelectV2
            isClearable
            value={options?.find(({ value }) => value === columnFilterValue)}
            onChange={(newValue) => {
                if (Array.isArray(newValue)) {
                    column.setFilterValue(newValue.map(option => option.value))
                } else {
                    column.setFilterValue(newValue?.value)
                }
            }}
            options={options}
        />
    ) : filterVariant === 'multiSelect' ? (
        <SelectV2
            isMulti
            isClearable
            value={multiSelectValue()}
            onChange={(newValue) => {
                if (Array.isArray(newValue)) {
                    column.setFilterValue(
                        newValue?.length > 0 ? newValue.map(option => option.value) : null,
                    )
                } else {
                    column.setFilterValue(newValue?.value)
                }
            }}
            options={options}
        />
    ) : filterVariant === 'switch' ? (
        <SwitchV2
            checked={columnFilterValue === options?.[1]?.value}
            onChange={value => {
                column.setFilterValue(
                    value
                        ? options[1].value
                        : options[0].value,
                )
            }}
            options={options}
        />
    ) : filterVariant === 'checkboxes' ? (
        <CheckboxPickerV2
            onChange={value => {
                column.setFilterValue(value)
            }}
            options={options || []}
        />
    ) : (
        <InputV2
            type="text"
            value={columnFilterValue ?? ''}
            onChange={value => {
                const filterValue =
                    value && typeof value === 'object' && 'target' in value
                        ? value.target.value
                        : value
                column.setFilterValue(filterValue)
            }}
            placeholder={placeholder || 'Filter'}
        />
    )
}